import * as React from 'react';
import {SVGProps} from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => {
  const key = Object.values(props || [])
    .join('')
    .replaceAll('%', '');
  return (
    <svg
      width={21}
      height={31}
      viewBox={'0 0 21 31'}
      {...props}
      fill={'none'}
      stroke={'none'}>
      <path
        fill={`url(#logoChar${key})`}
        fillOpacity={0.8}
        d="M19.919 23.077a5.124 5.124 0 0 0-.527-1.638c-.267-.51-.671-.934-1.216-1.275-.545-.34-1.29-.51-2.234-.51-.75 0-1.416.19-1.997.565-.58.376-1.12.849-1.617 1.42a23.75 23.75 0 0 0-1.452 1.856 23.494 23.494 0 0 1-1.453 1.856 8.623 8.623 0 0 1-1.616 1.456c-.58.4-1.234.613-1.96.637-.679.023-1.224-.115-1.635-.419a2.223 2.223 0 0 1-.835-1.183c-.145-.486-.159-1.018-.037-1.601a3.815 3.815 0 0 1 .8-1.639c.411-.51.955-.958 1.634-1.347.677-.388 1.5-.618 2.47-.69.144 0 .284-.007.417-.019s.272-.018.418-.018v-.037a8.508 8.508 0 0 0 2.323-.546 7.244 7.244 0 0 0 2.071-1.237 7.407 7.407 0 0 0 2.288-3.567 14.967 14.967 0 0 0 .6-4.968l-.037-.618a4.596 4.596 0 0 0-.09-.655c-.05-.23-.11-.491-.182-.783l-.037.037a1.588 1.588 0 0 0-.508-1.019c-.29-.267-.641-.4-1.053-.4-.412 0-.776.158-1.09.472a1.542 1.542 0 0 0-.472 1.128v.073l.073.327c.048.412.097.752.145 1.019.048.267.072.618.072 1.055 0 2.5-.485 4.308-1.452 5.423-.896 1.07-2.083 1.627-3.56 1.675-.992-.024-1.81-.248-2.451-.673a4.66 4.66 0 0 1-1.526-1.657 7.217 7.217 0 0 1-.78-2.257 14.435 14.435 0 0 1-.218-2.51c0-.438.023-.892.072-1.366.048-.473.127-.947.237-1.42.109-.472.26-.934.453-1.382.194-.448.436-.843.727-1.183.92-1.068 2.082-1.637 3.487-1.71.193.024.368.042.526.054.158.013.32.043.49.091.678.17 1.259.431 1.744.783.484.351.883.759 1.198 1.22 1.138-.243 2.094-.607 2.869-1.093a8.057 8.057 0 0 0 2.033-1.82 120.94 120.94 0 0 1-.563-1.51A53.911 53.911 0 0 0 15.906 0c-.533 1.261-1.356 2.183-2.47 2.766-.895-.727-1.833-1.224-2.814-1.492a8.73 8.73 0 0 0-5.483.254c-.812.316-1.507.704-2.088 1.165a6.038 6.038 0 0 0-1.453 1.674A9.824 9.824 0 0 0 .672 6.46c-.23.74-.4 1.492-.508 2.256-.11.764-.164 1.5-.164 2.202 0 1.941.303 3.592.908 4.95.29.705.672 1.335 1.143 1.893a8 8 0 0 0 1.617 1.456c-.848.534-1.531 1.164-2.052 1.893a6.802 6.802 0 0 0-1.09 2.312 6.3 6.3 0 0 0-.145 2.42c.109.8.375 1.521.8 2.165a5.156 5.156 0 0 0 1.706 1.602c.714.424 1.58.649 2.597.673 1.041.048 1.98-.122 2.815-.509a9.163 9.163 0 0 0 2.252-1.474 12.856 12.856 0 0 0 1.779-1.948 96.1 96.1 0 0 0 1.417-1.966c.422-.607.804-1.11 1.143-1.51.339-.4.678-.6 1.018-.6.557 0 .865.205.926.618.06.412.09 1.006.09 1.784 0 .864.7 1.565 1.562 1.565.862 0 1.561-.701 1.561-1.565 0-.486-.043-1.02-.127-1.602l-.001.002Z"
      />
      <defs>
        <linearGradient
          id={`logoChar${key}`}
          x1={9.348}
          x2={9.348}
          y1={0}
          y2={30.29}
          gradientUnits="userSpaceOnUse">
          <stop stopColor={'#009F9C'} />
          <stop offset={1} stopColor={'#007BB2'} />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default SvgComponent;
